import { pattern } from '@endurancewarranty/lib';
import { ContractTypeEnum } from '@lib/enums';

const { match, P } = pattern;

export type TResolveWrapUpDestinationParams = {
  quoteId?: Maybe<string>;
  consumerId?: Maybe<string>;
  contactId?: Maybe<string>;
  lastTouchedQuoteId?: Maybe<string>;
  lastTouchedConsumerId?: Maybe<number>;
  lastTouchedHomeQuoteId?: Maybe<number>;
  lastTouchedQuoteType?: Maybe<ContractTypeEnum>;
};

export type TWrapUpDestination =
  | { type: 'quote'; quoteId: string }
  | { type: 'homeQuote'; homeQuoteId: number }
  | { type: 'consumer'; consumerId: string }
  | { type: 'contact'; contactId: string }
  | { type: 'none' };

export function resolveWrapUpDestination(
  params: TResolveWrapUpDestinationParams,
): TWrapUpDestination {
  const {
    quoteId,
    consumerId,
    contactId,
    lastTouchedQuoteId,
    lastTouchedConsumerId,
    lastTouchedHomeQuoteId,
    lastTouchedQuoteType,
  } = params;

  return match({
    consumerId,
    contactId,
    lastTouchedConsumerId,
    lastTouchedHomeQuoteId,
    lastTouchedQuoteId,
    lastTouchedQuoteType,
    quoteId,
  })
    .with({ quoteId: P.nonNullable }, ({ quoteId }): TWrapUpDestination => ({
      type: 'quote',
      quoteId,
    }))
    .with(
      {
        lastTouchedQuoteType: ContractTypeEnum.Home,
        lastTouchedHomeQuoteId: P.nonNullable,
        lastTouchedConsumerId: P.nonNullable,
        consumerId: lastTouchedConsumerId?.toString(),
      },
      ({ lastTouchedHomeQuoteId }): TWrapUpDestination => ({
        type: 'homeQuote',
        homeQuoteId: lastTouchedHomeQuoteId,
      }),
    )
    .with(
      {
        lastTouchedQuoteId: P.nonNullable,
        lastTouchedConsumerId: P.nonNullable,
        consumerId: lastTouchedConsumerId?.toString(),
      },
      ({ lastTouchedQuoteId }): TWrapUpDestination => ({
        type: 'quote',
        quoteId: lastTouchedQuoteId,
      }),
    )
    .with({ consumerId: P.nonNullable }, ({ consumerId }): TWrapUpDestination => ({
      type: 'consumer',
      consumerId,
    }))
    .with({ contactId: P.nonNullable }, ({ contactId }): TWrapUpDestination => ({
      type: 'contact',
      contactId,
    }))
    .otherwise((): TWrapUpDestination => ({ type: 'none' }));
}
